import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { applyKeycloakPassivePolicy } from './keycloak-passive-policy';
import {
  buildKeycloakBearerExcludedUrls,
  normalizeKeycloakServerBase,
} from './keycloak-http.config';
import { KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS } from './keycloak-refresh.constants';
import { shouldAttemptKeycloakTokenRefresh } from './keycloak-should-update-token';
import { wrapKeycloakUpdateTokenSingleFlight } from './keycloak-update-token-single-flight';

/**
 * `APP_INITIALIZER`: arranca o adapter Keycloak (OIDC + PKCE), regista o `KeycloakBearerInterceptor`
 * e aplica política passiva ou single-flight consoante o ambiente.
 */
export function createKeycloakInitializer(keycloak: KeycloakService): () => Promise<void> {
  const kcBase = normalizeKeycloakServerBase(environment.keycloak.url);
  const bearerExcludedUrls = buildKeycloakBearerExcludedUrls(environment.keycloak.url);

  return () =>
    keycloak
      .init({
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId,
        },
        updateMinValidity: KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS,
        initOptions: {
          checkLoginIframe: false,
          monitorSession: false,
          onLoad: 'login-required',
          pkceMethod: 'S256',
        } as import('keycloak-js').KeycloakInitOptions,
        shouldUpdateToken: (req) =>
          shouldAttemptKeycloakTokenRefresh(req, keycloak.getKeycloakInstance(), kcBase),
        enableBearerInterceptor: true,
        bearerPrefix: 'Bearer',
        bearerExcludedUrls,
      })
      .then(() => {
        if (environment.keycloak.passiveKeycloakPolicy === true) {
          applyKeycloakPassivePolicy(keycloak);
        } else {
          wrapKeycloakUpdateTokenSingleFlight(keycloak.getKeycloakInstance());
        }
      });
}
